import {State} from "./VirtualizedList.types";
import {MagicReducerObject} from "@witivio_teamspro/use-reducer";
import {startTransition} from "react";
import Swiper from "swiper";

export const initialState: State = {
    container: null,
    swiperHeight: 0,
    itemHeight: 0,
    scrollbar: undefined,
    releaseOnEdges: true,
}

export const reducer = {
    containerRef: ({state, setState}, [container]: [HTMLDivElement | null]) => {
        setState({container}, false);
        const containerHeight = container?.clientHeight || 0;
        if (!containerHeight || state.swiperHeight === containerHeight) return;
        startTransition(() => setState({swiperHeight: containerHeight}));
    },
    setItemHeight: ({state, setState}, [item]: [HTMLDivElement | null]) => {
        const itemHeight = item?.clientHeight || 0;
        if (!itemHeight || state.itemHeight === itemHeight) return;
        startTransition(() => setState({itemHeight}));
    },
    swiperRef: ({setState}, [swiper]: [Swiper]) => {
        setState({scrollbar: swiper.scrollbar.el});
    },
    scrollbarResized: ({state, setState}) => {
        const scrollbarHeight = state.scrollbar?.clientHeight || 0;
        const releaseOnEdges = scrollbarHeight <= 0;
        if (state.releaseOnEdges === releaseOnEdges) return;
        setState({releaseOnEdges});
    },
    scroll: ({state}, [, e]: [Swiper, WheelEvent]) => {
        if (state.releaseOnEdges) return;
        const yDelta = e.deltaY;
        if (yDelta > 20) return;
        e.preventDefault();
    }
} satisfies MagicReducerObject<State>;